import { motion } from "framer-motion";

// Animation constants
const HERO_ANIMATION = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8 }
};

// Hero Section for homepage
const HeroSection = () => {
  return (
    <section 
      data-testid="hero-section"
      className="relative min-h-[90vh] flex items-center justify-center"
      style={{
        backgroundImage: `url('https://customer-assets.emergentagent.com/job_market-for-good/artifacts/n4bq3bao_Produce%20-%20mom%20and%20boy.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 hero-overlay"></div>
      
      {/* Main hero content centered */}
      <div className="relative z-10 flex items-center justify-center px-4 md:px-8">
        <motion.div
          initial={HERO_ANIMATION.initial}
          animate={HERO_ANIMATION.animate}
          transition={HERO_ANIMATION.transition}
          className="text-center max-w-4xl mx-auto"
        >
          <h1 
            data-testid="hero-title"
            className="text-5xl sm:text-6xl lg:text-7xl font-black text-white mb-4 tracking-tight leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Murphy's Giving Market
          </h1>
          
          <p 
            data-testid="hero-tagline"
            className="text-2xl md:text-3xl text-white/90 max-w-2xl mx-auto leading-relaxed mb-8"
          >
            A Community Resource Center
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
